import React from "react";
import imagen from "../../../generalComponents/images/logoBPW.png";

export const ParticularInventoryInitial = () => {
	return (
		<div>
			<div className="containerIcon">
				<h2> INVENTARIO PROPIO </h2>
				<br />
				<br />
				<br />
				<img src={imagen} />
			</div>
		</div>
	);
};
